import { useState } from 'react';

import PageContentWrapper from '@/components/templates/PageContentWrapper';
import { HiddenColumnsIndicator } from '@/components/ui/table/hidden-columns-indicator';
import { trackEvent } from '@/segment/segment';
import { EventName } from '@/shared/types/segment';
import { TABLE_LAYOUT_FILL_CLASSES } from '@/util/constants';

import { CampaignLogsToolbar } from '../../components/CampaignLogsToolbar';
import { ResumeSubscriberModal } from '../../components/modals/ResumeSubscriberModal';
import { StopSubscriberModal } from '../../components/modals/StopSubscriberModal';
import { CampaignLogsTable } from '../../components/Tables/CampaignLogsTable/Table';
import { useCampaignLogsPage } from '../../hooks/useCampaignLogsPage';

export const PaymentRecoveryLogs = () => {
  const page = useCampaignLogsPage({ logsPathSegment: 'payment-recovery/logs' });
  const [stopSubscriberId, setStopSubscriberId] = useState<string | null>(null);
  const [resumeSubscriberId, setResumeSubscriberId] = useState<string | null>(null);

  const hiddenColumnsIndicator = page.hasHiddenColumns ? (
    <HiddenColumnsIndicator
      onCustomize={() => page.setIsCustomizeColumnsOpen((prev) => !prev)}
      buttonRef={page.customizeButtonRef}
    />
  ) : undefined;

  return (
    <>
      <PageContentWrapper noGutters>
        <div className={TABLE_LAYOUT_FILL_CLASSES}>
          <CampaignLogsToolbar page={page} />

          <CampaignLogsTable
            data={page.currentPageData}
            fetchNextPage={page.goToNextPage}
            hasNextPage={page.hasNextPage}
            currentPageIndex={page.currentPageIndex}
            setCurrentPageIndex={page.setCurrentPageIndex}
            rowCount={page.totalRows}
            isLoading={page.listStatus === 'pending'}
            isFetchingNextPage={page.isFetchingNextPage}
            lastSeen={page.lastSeen}
            onReplay={page.triggerReplay}
            campaign_senders={page.campaign_senders}
            onRowClick={page.onRowClick}
            getRowClickable={page.getRowClickable}
            getRowHref={page.getRowHref}
            onStopClick={(id) => {
              trackEvent(EventName.CampaignStopSubscriber, { campaign_id: page.campaignId });
              setStopSubscriberId(id);
            }}
            onResumeClick={(id) => {
              trackEvent(EventName.CampaignResumeSubscriber, { campaign_id: page.campaignId });
              setResumeSubscriberId(id);
            }}
            campaignStatus={page.campaign?.status}
            isAgentic={page.hasNbaConfig}
            hideReplay={page.hasNbaConfig}
            columnVisibility={page.columnVisibility}
            onColumnVisibilityChange={page.setColumnVisibility}
            sorting={page.sorting}
            onSortingChange={page.setSorting}
            paginationCenterContent={hiddenColumnsIndicator}
          />
        </div>
      </PageContentWrapper>

      {stopSubscriberId && page.campaignId && (
        <StopSubscriberModal
          campaignId={page.campaignId}
          subscriberId={stopSubscriberId}
          onClose={() => setStopSubscriberId(null)}
        />
      )}

      {resumeSubscriberId && page.campaignId && (
        <ResumeSubscriberModal
          campaignId={page.campaignId}
          subscriberId={resumeSubscriberId}
          onClose={() => setResumeSubscriberId(null)}
        />
      )}
    </>
  );
};
